import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  retrieveOrdersData, retrieveSingleOrderData, insertBandejaInOF, deleteArrayElementFromDocument, findTipoDatoHornoForDisp,
  insertMuestra, insertComentario
} from 'src/app/models/graphQL/retrieveOrdersData.request';
import { mongoMaestrosRequest } from 'src/app/models/graphQL/mongoMaestros.request';
import { findDispositivos } from 'src/app/models/graphQL/findDispositivos.request';


@Injectable({
  providedIn: 'root'
})
export class OrdenesServiceService {

  constructor(private apollo: Apollo) { }

  findTipoDatoHornoForDisp(uuid: string) {
    return this.apollo.query<any>({
      query: findTipoDatoHornoForDisp,
      variables: {
        uuid: uuid
      },
      fetchPolicy: 'network-only'
    })
  }

  findDataMaestros() {
    return this.apollo.query<any>({
        query: mongoMaestrosRequest,
        variables: {
            _id: "maestros"
        }
    })
  }

  findDispositivos() {
    return this.apollo.query<any>({
      query: findDispositivos
    })
  }

  getSingleOFData(td: string, id: string) {
    return this.apollo.query<any>({
      query: retrieveSingleOrderData,
      variables: {
        td: td,
        id: id
      },
      fetchPolicy: 'network-only'
    })
  }

  retrieveOrdersData(td: string) {
    return this.apollo.query<any>({
      query: retrieveOrdersData,
      variables: {
        td: td
      },
      fetchPolicy: 'network-only'
    })
  }


  editBandejaByID(id: string) {
    return this.apollo.query<any>({
      query: retrieveSingleOrderData,
      variables: {
        id: id
      },
      fetchPolicy: 'network-only'
    })
  }

  insertBandejaInOF(id: string, usuario: string, usuarioUUID: string, cantidad: number, tipo: string, fecha: any) {
    return this.apollo.mutate<any>({
      mutation: insertBandejaInOF,
      variables: {
        _id: id,
        usuario: usuario,
        usuarioUUID: usuarioUUID,
        cantidad: cantidad,
        tipo: tipo,
        fecha: fecha
      },
      fetchPolicy: 'no-cache'
    })

  }

  insertMuestra(id: string, usuario: string, usuarioUUID: string, valor: number, unidad: string, fecha: number) {
    return this.apollo.mutate<any>({
      mutation: insertMuestra,
      variables: {
        _id: id,
        usuario: usuario,
        usuarioUUID: usuarioUUID,
        valor: valor,
        unidad: unidad,
        fecha: fecha
      },
      fetchPolicy: 'no-cache'
    })

  }


  insertComentario(id: string, usuario: string, usuarioUUID: string, valor: string, tipo: string, fecha: number) {
    return this.apollo.mutate<any>({
      mutation: insertComentario,
      variables: {
        _id: id,
        usuario: usuario,
        usuarioUUID: usuarioUUID,
        valor: valor,
        tipo: tipo,
        fecha: fecha
      },
      fetchPolicy: 'no-cache'
    })
  };


  deleteArrayElementFromDocument(td: string, id: string, idx: number, arrayName: string) {
    return this.apollo.mutate<any>({
      mutation: deleteArrayElementFromDocument,
      variables: {
        _id: id,
        td: td,
        idx: idx,
        arrayName: arrayName

      },
      fetchPolicy: 'no-cache'
    })

  }

  

}
